import { client } from "Service/axios";
import {
  COMMON_LABEL_ID,
  COMMON_LABELS,
  COMMON_LABELS_CREATE,
} from "Shared/Constants/apiRequest";
import { IAddLabelsType, ILabelsTypeSearchList } from "Shared/Types/labels";
import { Label } from "Shared/Types/fleetmanagementapi";

class LabelsType {
  getLabelsTypeList(params: ILabelsTypeSearchList | null) {
    return client.get<any>(COMMON_LABELS, { params });
  }
  getLabelType(id: string) {
    return client.get<Label>(COMMON_LABEL_ID(id));
  }
  addLabelsType(data: IAddLabelsType) {
    return client.post<any>(COMMON_LABELS_CREATE, data);
  }
}

export default LabelsType;
